<template>

  <div class="conationer">

    <div id="root" class="root" />
    <div id="rootSuccess" class="root-success" />
    <div id="shadowSuccess" class="shadow">
      <img src="@/assets/dfReserve/bananza.png" alt="">
      <img onclick="cross()" src="@/assets/dfReserve/X.png" alt="">
    </div>
    <div class="top">
      <div class="box">
        <div class="btn">
          <div class="play" />
          <div class="playP">
            <div class="parentPlay" @click="openVideo" />
          </div>
        </div>
        <div class="textBtn">
          <div class="imgBTn">
            <img src="../../assets/change/newImg0.png" alt="" @click="open()">
            <img
              style="display: none"
              src="@/assets/dfReserve/4.png"
              alt=""
            >
          </div>
          <div class="Welfare">
            <div class="WelfareImg">
              <div class="boximg1" />
              <div class="boximg2" />
              <div class="boximg3" />
            </div>
          </div>
          <div class="p" />
          <div class="feature">
            <div class="featureImg">
              <div class="featureimg1" />
              <div class="featureimg2" />
              <div class="featureimg3" />
            </div>
            <div class="banner">
              <div class="swiper-container">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <img
                      src="@/assets/dfReserve/13.png"
                    >
                  </div>
                  <div class="swiper-slide">
                    <img
                      src="@/assets/dfReserve/14.png"
                    >
                  </div>
                  <div class="swiper-slide">
                    <img
                      src="@/assets/dfReserve/15.png"
                    >
                  </div>
                  <div class="swiper-slide">
                    <img
                      src="@/assets/dfReserve/16.png"
                    >
                  </div>
                  <div class="swiper-slide">
                    <img
                      src="@/assets/dfReserve/17.png"
                    >
                  </div>
                </div>
                <!-- 如果需要滚动条 -->
                <!-- <div class="swiper-scrollbar"></div> -->
              </div>
              <!-- 如果需要分页器 -->
              <div class="swiper-pagination" />

            </div>

            <div class="figure">
              <div class="figureImg">
                <div class="figureimg1" />
                <div class="figureimg2" />
                <div class="figureimg3" />
              </div>
            </div>

            <div class="figureBanner">
              <div class="swiper-container2">
                <div class="swiper-wrapper">
                  <div class="swiper-slide">
                    <img
                      src="@/assets/dfReserve/1.png"
                    >
                  </div>
                  <div class="swiper-slide">
                    <img
                      src="@/assets/dfReserve/2.png"
                    >
                  </div>
                  <div class="swiper-slide">
                    <img
                      src="@/assets/dfReserve/33.png"
                    >
                  </div>
                  <div class="swiper-slide">
                    <img
                      src="@/assets/dfReserve/44.png"
                    >
                  </div>
                  <div class="swiper-slide">
                    <img
                      src="@/assets/dfReserve/5.png"
                    >
                  </div>
                  <div class="swiper-slide">
                    <img
                      src="@/assets/dfReserve/6.png"
                    >
                  </div>
                  <div class="swiper-slide">
                    <img
                      src="@/assets/dfReserve/7.png"
                    >
                  </div>
                  <div class="swiper-slide">
                    <img
                      src="@/assets/dfReserve/8.png"
                    >
                  </div>
                  <div class="swiper-slide">
                    <img
                      src="@/assets/dfReserve/9.png"
                    >
                  </div>
                </div>
                <!-- 如果需要滚动条 -->
                <!-- <div class="swiper-scrollbar"></div> -->
              </div>
              <!-- 如果需要分页器 -->

            </div>
          </div>

        </div>
      </div>

    <!-- <div class="footer"></div> -->
    </div>
    <div class="foot">
      <div class="title">详细信息</div>
      <ul class="ul">
        <li>
          <span>开发商</span>
          <span>Good Smile Company×NextNinja</span>
        </li>
        <li>
          <span>运营厂商</span>
          <span>幻域云起制作组</span>
        </li>
        <li>
          <span>应用版本</span>
          <span>1.9.0</span>
        </li>
        <li>
          <span>应用权限</span>
          <span> <router-link tag="a" target="_blank" to="/appPermissions">权限详情> </router-link></span>
        </li>
        <li>
          <span>隐私政策</span>
          <span>  <router-link tag="a" target="_blank" to="/privacy">隐私详情></router-link> </span>
        </li>

      </ul>
    </div>
    <PlayVideo v-if="showPlayVideo" ref="PlayVideo" :video-data="videoData" />
    <MobileReserveModels ref="MobileReserveModels" />
  </div>
</template>

<script>
import PlayVideo from '../components/PlayVideo'
import MobileReserveModels from '../../components/MobileReserveModels'
import device from '@/utils/GetDeviceInformation'
import Swiper from 'swiper'
import { reqGetLinks } from "@/api/news.js"
import { getLinksParams } from "@/utils/getDownloadLinks.js"
export default {
  name: 'DfDownload',
  components: {
    PlayVideo,
    MobileReserveModels
  },
  data() {
    return {
      showPlayVideo: false,
      videoData: {
        src: 'https://thcdn.gggamedownload.com/apk/lwop.mp4'
      },
      show: false,
      lostworld_ios: "",
      lostworld_android: "",
      lostworld_pc: ""
    }
  },
  mounted() {
    this.swiper = new Swiper(".swiper-container2", {
      autoplay: true, // 自动播放
      loop: true, // 循环播放
      delay: 4000 // 每张图间隔四秒

    });
    this.swiper = new Swiper(".swiper-container", {
      autoplay: true, // 自动播放
      loop: true, // 循环播放
      delay: 3000, // 每张图间隔三秒
      // 分页器
      pagination: {
        el: ".swiper-pagination"
      }

    });
  },
  created() {
    this.getDownloadLinks()
  },
  methods: {
    openVideo() {
      this.showPlayVideo = true
    },
    clickDownLoad(url, type) {
      const link = document.createElement('a');
      if (type === 'lostworld_android') {
        const ourkey = 'RILvS9HYMOsiFptQ75dgW38V6Bh2Jyw';
        const time = Date.parse(new Date()) / 1000;
        const uri = url.split("com")[1]; // 取com后面的所有值
        const key = this.$md5(`${uri}${ourkey}${time}`); // 转 md5 密钥计算参数

        link.href = url + `?key=${key}&time=${time}`; // 设置下载链接
      } else {
        link.href = url; // 设置下载链接
      }
      link.download = url.substring(url.lastIndexOf("/") + 1); // 设置下载文件的名称 取最后一个/后面的内容为下载名字
      // 将 <a> 标签添加到 DOM 中
      document.body.appendChild(link);
      // 触发点击事件
      link.click();
      // 删除添加的 <a> 标签
      document.body.removeChild(link);
    },
    open() {
      if (device === "ios") {
        this.clickDownLoad(this.lostworld_ios)
      } else {
        this.clickDownLoad(this.lostworld_android, 'lostworld_android')
      }
    },
    async getDownloadLinks() {
      const res = await reqGetLinks(getLinksParams)

      res.data.forEach(item => {
        this[item.keywords] = item.data
      })
    }
  }
}
</script>
<style scoped lang="scss">
::v-deep {
    .swiper-pagination-bullet{
      margin: 0 5px;
    }
}
.foot {
  padding: 15px 0;
  background: url('~@/assets/download/jieshao.png') no-repeat;
  font-size: 13px;
  color: #7f3a17;
  .title {
    font-size: 16px;
    font-weight: 700;
    padding-left: 23px;
  }
  .ul {
    li {
      display: flex;
      justify-content: space-between;
      position: relative;
        padding: 10px 23px;
        // border-bottom: 1px solid #b58666;
      &::after {
        content: '';
        position: absolute;
        bottom: 0;
        left: 50%;
        transform: translateX(-50%) scaleY(0.2);
        height: 1px;
        width: 70%;
        background-color: #b58768;
      }
      a {
         font-size: 13px;
         color: #7f3a17;
      }
    }
  }
}
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
ul,
li {
  list-style: none;
}

html {
  height: 100%;
}
body {
  height: 100%;
}
.conationer {
  height: 100%;
  position: relative;
}
.top {
}
.top .box {
  width: 100%;
  height: 127rem;
  background: url('~@/assets/dfReserve/BG.jpg') no-repeat top;
  // background: url('../../assets/change/newImg1.jpg') no-repeat top;
  background-size: 100% 100%;
}
.top .box .btn {
  width: 100%;
  height: 27.5rem;
  margin: 0 auto;
  position: relative;
}

.top .box .video {
  display: none;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 111;
}
.top .box .video .videoBox {
  text-align: right;
  width: 100%;
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}
.top .box .video .videoBox video {
  width: 100%;
}
.top .box .video .videoBox img {
  transform: scale(75%);
}
@-webkit-keyframes changeright {
  0% {
    -webkit-transform: rotate(0deg);
  }

  50% {
    -webkit-transform: rotate(180deg);
  }

  100% {
    -webkit-transform: rotate(360deg);
  }
}

.top .box .btn .parentPlay {
  -webkit-animation: changeright 6s linear infinite;
  position: absolute;
  bottom: 0.625rem;
  left: 50%;
  margin-left: -54px;
  width: 120px;
  height: 120px;
  background: url('~@/assets/dfReserve/02.png') no-repeat center;
  background-size: 100%;
}

.top .box .btn .play {
  width: 120px;
  height: 120px;
  position: absolute;
  bottom: 0.625rem;
  left: 50%;
  margin-left: -54px;
  /* transform: translateX(-50%); */
  background: url('~@/assets/dfReserve/01.png') no-repeat center;
  background-size: 75%;
}

.top .box .textBtn {
  width: 100%;
  height: 18.75rem;
  padding-top: 5rem;
}
.top .box .textBtn .imgBTn {
  /* height: 50px; */
}
.top .box .textBtn .imgBTn img {
  width: 100%;
}
.top .box .textBtn .Welfare {
  display: flex;
  padding-top: 0.9375rem;
  justify-content: center;
  text-align: center;
}

.top .box .textBtn .Welfare .WelfareImg {
  display: flex;
  justify-content: space-around;
  width: 100%;
}
.top .box .textBtn .Welfare .WelfareImg .boximg1 {
  width: 6.25rem;
  height: 3.125rem;
  background: url('~@/assets/dfReserve/07.png') no-repeat center;
  background-size: 100%;
}
.top .box .textBtn .Welfare .WelfareImg .boximg2 {
  width: 6.875rem;
  height: 3.125rem;
  background: url('~@/assets/dfReserve/05.png') no-repeat center;
  background-size: 100%;
}
.top .box .textBtn .Welfare .WelfareImg .boximg3 {
  width: 6.25rem;
  height: 3.125rem;
  background: url('~@/assets/dfReserve/08.png') no-repeat center;
  background-size: 100%;
}

.top .box .textBtn .p {
  width: 100%;
  height: 23.125rem;
}
.top .box .textBtn .feature {
  width: 100%;
  height: 23.125rem;
}

.top .box .textBtn .feature .featureImg {
  display: flex;
  justify-content: space-around;
  width: 100%;
}
.top .box .textBtn .feature .featureImg .featureimg1 {
  width: 6.25rem;
  height: 3.125rem;
  background: url('~@/assets/dfReserve/07.png') no-repeat center;
  background-size: 100%;
}
.top .box .textBtn .feature .featureImg .featureimg2 {
  width: 6.875rem;
  height: 3.125rem;
  background: url('~@/assets/dfReserve/09.png') no-repeat center;
  background-size: 100%;
}
.top .box .textBtn .feature .featureImg .featureimg3 {
  width: 6.25rem;
  height: 3.125rem;
  background: url('~@/assets/dfReserve/08.png') no-repeat center;
  background-size: 100%;
}
.top .box .textBtn .banner {
  transform:translate3d(0,0,0);

  padding-top: 1.875rem;

}
.banner .swiper-container img {
  width: 100%;
  transform:translate3d(0,0,0);
}
.banner .swiper-pagination {
  padding-top: 1.25rem;
  left: 50%;
  transform: translateX(-50%);
}

.banner .swiper-container .swiper-slide {
  padding: 0 1.375rem;
}
::v-deep{
.banner .swiper-pagination .swiper-pagination-bullet {
  margin: 0 0.375rem;
  width: 0.875rem;
  height: 0.875rem;
  border-radius: 0;
  transform: rotate(45deg);
  border: 0.125rem solid #884320;
  background-color: #ecddcf;

}
.banner .swiper-pagination .swiper-pagination-bullet-active {
  background-color: #7f3a17;
}
}

.top .box .textBtn .figure {
  width: 100%;
  padding-top: 4.375rem;
  /* height: 23.125rem; */
}

.top .box .textBtn .figure .figureImg {
  display: flex;
  justify-content: space-around;
  width: 100%;
}
.top .box .textBtn .figure .figureImg .figureimg1 {
  width: 6.25rem;
  height: 3.125rem;
  background: url('~@/assets/dfReserve/07.png') no-repeat center;
  background-size: 100%;
}
.top .box .textBtn .figure .figureImg .figureimg2 {
  width: 6.875rem;
  height: 3.125rem;
  background: url('~@/assets/dfReserve/012.png') no-repeat center;
  background-size: 100%;
}
.top .box .textBtn .figure .figureImg .figureimg3 {
  width: 6.25rem;
  height: 3.125rem;
  background: url('~@/assets/dfReserve/08.png') no-repeat center;
  background-size: 100%;
}
.figureBanner {
  transform:translate3d(0,0,0);
  overflow: hidden;
}
.figureBanner .swiper-container2 img {
  transform:translate3d(0,0,0);
  width: 100%;
}
.Reserve {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 99;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
}
.Reserve .ReserveBox {
  width: 100%;
  /* height: 25rem; */
}
.Reserve .ReserveBox .box {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 20rem;
  height: 19rem;
  background: url('~@/assets/dfReserve/game_reserve.png')
    no-repeat;
  background-size: 20rem 19rem;
  /* margin-left: 50%;
  margin-top: 10rem; */
  transform: translateX(-50%) translateY(-50%);
  z-index: 3;
}
.Reserve .ReserveBox .box .cancel {
  width: 1.625rem;
  margin-left: 19.9rem;
  margin-top: 2.6rem;
}
.Reserve .ReserveBox .ios-style {
  display: block;
  width: 3.668rem;
  height: 1rem;
  margin-left: 4rem;
}

.Reserve .ReserveBox .android-style {
  display: block;
  /* margin-left: 10rem; */
  margin: 0 auto;
  width: 6.12rem;
  height: 1rem;
  margin-top: -0.96rem;
}

.Reserve .ReserveBox .ios-y {
  display: block;
}

.Reserve .ReserveBox .android-y {
  display: block;
}

.Reserve .ReserveBox .ios-n {
  display: none;
}

.Reserve .ReserveBox .android-n {
  display: block;
}

.box .alert-content {
  text-align: center;
  margin: 0.2rem auto;
}

.box .alert-content .base-input {
  width: 14rem;
  height: 2rem;
  margin-top: 1rem;
  border-radius: 0.625rem;
  border: 0.0625rem solid #ccc;
  font-size: 1rem;
  padding-left: 1.18rem;
}

.box .alert-content .phone-code {
  width: 8.8rem;
  height: 2rem;
  vertical-align: middle;
  box-sizing: border-box;
  border-radius: 0.625rem 0 0 0.625rem;
}

.box .alert-content .base-viewport {
  width: 5.4rem;
  height: 2rem;
  font-size: 0.75rem;
  border: 0;
  background-color: #858ba2;
  color: #fff;
  border-radius: 0 0.625rem 0.625rem 0;
  margin-left: -0.34rem;
  vertical-align: bottom;
}

.box .alert-content img {
  width: 10rem;
  position: absolute;
  top: 15rem;
  left: 50%;
  margin-top: 0.3125rem;
  transform: translateX(-50%);
}

.box .alert-content .error {
  font-size: 0.75rem;
  color: #ff0000;
  margin: 0.2rem 0 -0.6rem -6rem;
}

.root {
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  position: fixed;
  top: 0;
  left: 0;
  display: none;
  z-index: 2;
}

.shadow {
  position: fixed;
  top: 30%;
  left: 50%;
  transform: translateX(-50%);
  display: none;
  z-index: 3;
  /* width: 100%;
  height: 100vh; */
}

.shadow img:nth-child(1) {
  width: 16.8rem;
}

.shadow img:nth-child(2) {
  width: 1.5rem;
  position: absolute;
  top: 0;
  right: -1.6rem;
}

.root-success {
  width: 100%;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.9);
  position: fixed;
  top: 0;
  left: 0;
  display: none;
  z-index: 3;
}

</style>

